import React from "react";
import { useField } from "formik";
import { useTranslation } from "react-i18next";

import "./LoginCompleteSetupCheckbox.css";

import { Icon } from "../../../Icon/Icon";

export const LoginCompleteSetupCheckbox = ({ checked, ...props }) => {
  const { t } = useTranslation();
  const [field, , helpers] = useField({ ...props });

  const onChangeHandler = () => {
    helpers.setValue(!checked);
  };

  const createTranslatedMarkup = () => {
    return {
      __html: t("loginForm.termsAndConditions", {
        EULALink: "https://www.eflowsoftware.com/about-us/eula",
        DPALink:
          "https://www.eflowsoftware.com/about-us/data-processing-agreement",
      }),
    };
  };
  return (
    <div className="LoginCompleteSetupCheckbox">
      <div className="LoginCompleteSetupCheckbox__checkbox">
        <div className="CustomCheckbox" onClick={onChangeHandler}>
          {field.checked && (
            <div className="CustomCheckbox__checked">
              <Icon name="iconCheckmark" width={10} height={10} />
            </div>
          )}
        </div>
      </div>

      <div
        className="LoginCompleteSetupCheckbox__label"
        dangerouslySetInnerHTML={createTranslatedMarkup()}
      ></div>
    </div>
  );
};
